<template>
  <Heading v-editable="blok" :class="[blok.color ? `heading--${blok.color}`: '', blok.size ? `heading--${blok.size}` : '']">
    {{ blok.text }}
  </Heading>
</template>
<script setup>
defineProps({ blok: Object })
</script>
